
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/duck",
      function () {
        return require("private-next-pages/recipes/duck.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/duck"])
      });
    }
  